<template>
  <div class="inspect-left" v-loading="routeLoading || pointLoading" element-loading-background="rgba(0, 0, 0, 0.5)">
    <div class="route-top">
      <div class="flex justify-center">
        <span>巡检路线：</span>
        <span class="mr-4px">{{isShowRoute ? '显示' : '隐藏'}}</span>
        <el-switch v-model="isShowRoute" active-color="#2CE1D9" inactive-color="#0E2E3C"  @change="(e) => routeChange(e)"></el-switch>
      </div>
      <div class="flex">
        <span class="play-rate">当前播放：{{ this.curPointInfo.idx + 1 }}/{{ this.allPoints.length }}</span>
        <img class="cursor-pointer" v-if="readStandard" src="../../../assets/images/inspect/read-standard.png" @click="closeVoice"/>
        <img class="cursor-pointer" v-else src="../../../assets/images/inspect/read-standard-not.png" @click="openVoice"/>
      </div>
    </div>

    <div class="route-list">
      <div class="route-item" v-for="(route, rIndex) in routeList" :key="route.routeId">
        <div
          class="route-title"
          :class="{ 'cur-route': curPointInfo.routeId === route.routeId }"
        >
          {{ route.name }} ({{ route.code }})
        </div>
        <div class="point-list">
          <div
            class="point-item"
            v-for="(point, index) in route.inspectPoints"
            :key="point.pointId"
            :id="point.pointId"
          >
            <div
              class="cursor-pointer point-item-info"
              :class="{ 'cur-point': curPointInfo.pointId === point.pointId }"
              @click="clickPoint(point, rIndex)"
            >
              <div class="point-item-title">
                <div class="title-box">
                  {{ index + 1 }}: {{ point.name }} ({{ point.code }})
                </div>
                <img class="icon-finished" v-if="point.finished && curPointInfo.pointId !== point.pointId" src="../../../assets/images/inspect/icon-finish.png" alt="">
              </div>
              <div v-if="curPointInfo.idx === point.idx && point.description.length" class="point-standard" :ref="`standardRef${curPointInfo.idx}`">
                <div class="point-standard-item">巡检标准:</div>
                <div v-for="(des, desIndex) in point.description" :key="desIndex" class="point-standard-item">{{ des }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stop-btn cursor-pointer" @click="$emit('endHandle')">结束巡检</div>

    <div class="route-play__btns">
      <el-popover
        placement="left"
        popper-class="speed-list-popover"
        width="100"
        trigger="hover"
      >
        <div slot="reference" class="change-speed">
          <span>调速</span>
          <div class="speed-text">{{curChangeSpeed}}x</div>
        </div>
        <div class="speed-popover-content">
          <div
            class="speed-item cursor-pointer"
            :class="{ 'cur-speed': item === curChangeSpeed }"
            v-for="item in speedList"
            :key="item"
            @click="changeSpeed(item)"
          >
            {{ item }}
          </div>
        </div>
      </el-popover>
      <div class="flex justify-between w-150px" >
        <div class="cursor-pointer" @click="prePoint">
          <img src="../../../assets/images/inspect/icon-pre.png" />
        </div>
        <div class="cursor-pointer">
          <img v-if="isPlay" src="../../../assets/images/inspect/icon-stop.png" @click="stopHandle"/>
          <img v-else src="../../../assets/images/inspect/icon-play.png" @click="playHandle"/>
        </div>
        <div class="cursor-pointer">
          <img src="../../../assets/images/inspect/icon-next.png" @click="clickNextPoint"/>
        </div>
      </div>
    </div>

    <!-- 设备测点面板 -->
    <div class="point-device-info">
      <div class="p-10px pb-0px" v-show="curTagInfo.tagName" >
        <cardTitle :title="`设备名称：${curTagInfo.tagName}`" />
      </div>
      <div v-show="curTagInfo.tagCode" class="device-info-item">
        <span class="label-text">设备编码：</span>{{ curTagInfo.tagCode }}
      </div>
      <div
        class="device-info-item"
        :class="item.alarmLevel"
        v-for="(item, index) in curTagInfo.measurePoints"
        :key="index"
      >
        <span :class="item.alarmLevel" class="label-text">{{ item.shortName || item.pointName }}：</span>{{ formatValue(item.value) }}{{ item.unit }}
      </div>
    </div>

    <!-- 退出的loading -->
    <!-- <div
      class="mask"
      v-if="backLoading"
      v-loading="backLoading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
      element-loading-text="退出中"
    ></div> -->
  </div>
</template>

<script>
import { formatValue } from '@/utils/basicTool'
import cardTitle from '@/components/cockpit/CardTitle'
import { InspectRouteApi, RoamPointApi, InspectPointApi } from '@wiz-api/roam-inspect-management'
import {
  mountVm, createPersonNode, setRamenNew, actionUpdate, initIdleAniInfo, setIdle,
  destroyVm, destroyIdleAniInfo, clearNextAni, compRamenRoute,
} from './js/person'

import { loadAction } from './js/loadAcition'

import {
  changeFollow, changeCameraSpeed, getRotateFinish, mountCameraVm, destroyCameraVm
} from './js/follow'

const inspectRouteApi = new InspectRouteApi()
const roamPointApi = new RoamPointApi()
const inspectPointApi = new InspectPointApi()

const signalR = require('@microsoft/signalr')

let inspectConnection = null
let inspectAutoDiscount = true
let speakDataMap = {} // 语音播报
let pointMarkerId = null

// 语音播报
let insertCount = 0// 插播标识
let voiceArr = []
let voiceIndex = 0
let stopVoice = false

function splitSpeech(str) { // 使用正则表达式切割文字转换为数组
  const temp = str.split(/[\n\s+,，;；.。!！：]/g)
  for (let i = 0; i < temp.length; i += 1) {
    if (!(temp[i].trim())) {
      temp.splice(i, 1)
      i -= 1
    }
  }
  return temp
}

// 开始播报语音
function startVoice(docStr) {
  voiceIndex = 0
  voiceArr = splitSpeech(docStr)
  if (voiceArr.length < 1) {
    return
  }

  const utterThis = new window.SpeechSynthesisUtterance()
  utterThis.onend = () => {
    if (stopVoice && !insertCount) {
      window.speechSynthesis.pause()
    }
    if (voiceArr.length > voiceIndex) {
      utterThis.text = voiceArr[voiceIndex]
      utterThis.rate = 1.5
      voiceIndex += 1
      if (insertCount) {
        utterThis.volume = 1
        utterThis.pitch = 2
        insertCount -= 1
      } else {
        utterThis.volume = 0.7
        utterThis.pitch = 1
      }
      window.speechSynthesis.speak(utterThis)
    }
  }
  utterThis.text = voiceArr[0]
  utterThis.rate = 1.5
  utterThis.volume = 0.7
  utterThis.pitch = 1
  voiceIndex += 1

  window.speechSynthesis.speak(utterThis)
}

// 插播一条报警语音
function interCutVoice(docInter, play) {
  if (voiceIndex >= voiceArr.length || play) {
    const obj = new window.SpeechSynthesisUtterance()
    if (stopVoice) {
      window.speechSynthesis.cancel()
      voiceArr = []
      stopVoice = false
    }
    obj.volume = 1
    obj.pitch = 2
    obj.rate = 1.5
    obj.text = docInter
    window.speechSynthesis.speak(obj)
  } else {
    insertCount += 1
    voiceArr.splice(voiceIndex, 0, docInter)
  }
}

export default {
  name: 'inspectScreen',
  components: {
    cardTitle
  },
  props: {
    playInfo: {
      type: Object,
      default: () => {
        return {
          batchNo: '', // 播放批次号
          routeIds: [],
          routePoints: [], // 经过筛选的点列表
        }
      },
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    // 是否展示报警闪烁
    showAlarmBlink: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      scrollTimer: null,
      scrollDirection: 'down',
      routeLoading: false,
      destroyLock: true, // 销毁锁，保证销毁的时候没有其他关于node 的操作在进行
      routeList: [],
      curPointInfo: {},
      allPoints: [], // 所有播放的巡检点
      isPlay: true, // 是否播放
      readStandard: true,
      playTimer: null,
      speedList: Object.freeze([0.25, 0.5, 0.75, 1.0, 1.5, 2.0, 4.0]),
      curChangeSpeed: '', // 当前倍数
      isManualSelectSpeed: false, // 是否自己手动选择的倍数
      tagList: [], // 绑定设备列表
      curTagIndex: 0,
      tagTimer: null,
      showAlarm: false, // 告警闪烁展示
      pointLoading: false,
      isPlaying: false, // 当前轨迹是否播放
      // 尝试使用新的方案
      personNode: null, // 创建小人时候保存小人的指针
      mixer: null, // 动画混合器
      ranmenRouteList: [], // 小人巡检路线，按照巡检点分段
      ramenIndex: 0, // 小人巡检段
      /**
       * 保存track信息
       * clip 动画片段对象
       * action 动画片段动作控制器
       * trackT trackR 轨道信息
       */
      actionData: {},
      shelterInterval: null, // 相机阻挡 intervalid
      mouseMoveTimeout: null, // 鼠标移动视角
      isShowRoute: false, // 是否展示路线
      backLoading: false, // 退出的loading
      cameraTimer: null,
      walking: false, // 小人正在两点的路上
    }
  },
  watch: {
    curTagInfo(val) {
      if (!val.measurePoints) return
      this.setAlarmVoice()
    },
    showAlarm(val) {
      const showAlarm = this.showAlarmBlink && val
      this.$emit('sendInfoToRightDialog', 'detail', { openAlarmFlicker: showAlarm, controlAlarm: true })
    },
    showAlarmBlink(val) {
      const showAlarm = this.showAlarm && val
      this.$emit('sendInfoToRightDialog', 'detail', { openAlarmFlicker: showAlarm, controlAlarm: true })
    }
  },
  computed: {
    curTagInfo() {
      return this.tagList[this.curTagIndex] || {}
    },
    colNum() {
      return { height: `${((this.curPointInfo.idx + 1) / this.allPoints.length) * 100}%` }
    },
    alarmLevelMap() {
      return {
        normal: 'none',
        slight: 'rgba(255, 210, 0, 0.6)',
        middle: 'rgba(255, 107, 0, 0.6)',
        serious: 'rgba(255, 255, 0, 0.6)',
      }
    },
    // websocket路径
    websocketServer() {
      return Wiz.GetModuleServer('roam-inspect-management')
    },
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
    // 静态资源文件前缀路径
    staticFilePath() {
      return `data://../apps/${this.modelSetting.folderName}/digitalSimulation`
    },
  },
  methods: {
    // 巡检标准滚动
    autoScroll() {
      const dom = this.$refs[`standardRef${this.curPointInfo.idx}`] && this.$refs[`standardRef${this.curPointInfo.idx}`][0]
      if (dom) {
        const scrollHeight = dom.scrollHeight
        const clientHeight = dom.clientHeight
        if (scrollHeight - clientHeight <= 0) return
        this.scrollFun()
      }
    },
    // 巡检标准滚动
    scrollFun() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
      this.scrollTimer = setInterval(() => {
        const dom = this.$refs[`standardRef${this.curPointInfo.idx}`] && this.$refs[`standardRef${this.curPointInfo.idx}`][0]
        if (!dom) {
          clearInterval(this.scrollTimer)
          return
        }
        const scrollHeight = dom.scrollHeight
        const clientHeight = dom.clientHeight
        const scrollTop = dom.scrollTop
        // 向下滚动
        if (this.scrollDirection === 'down') {
          dom.scrollTop = scrollTop + 1
          if (scrollHeight - clientHeight <= scrollTop + 1) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'up'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
          // 向上滚动
        } else if (this.scrollDirection === 'up') {
          dom.scrollTop = scrollTop - 1
          if (scrollTop - 1 <= 0) {
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            this.scrollDirection = 'down'
            setTimeout(() => {
              this.scrollFun()
            }, 1000)
          }
        }
      }, 150)
    },
    // 关闭语音
    closeVoice() {
      this.readStandard = false
      stopVoice = true
      if (!insertCount) {
        window.speechSynthesis.pause()
      }
    },
    // 打开语音
    openVoice() {
      this.readStandard = true
      if (stopVoice) {
        stopVoice = false
        window.speechSynthesis.resume()
      } else if (this.curPointInfo.standardText) {
        startVoice(this.curPointInfo.standardText)
      }
    },
    formatValue,
    // 播放倍数
    changeSpeed(speed) {
      this.curChangeSpeed = speed
      this.isManualSelectSpeed = true
      // 修改小人行走速度
      changeCameraSpeed(speed) // 修改相机过度时间
      if (this.mixer) {
        this.player.Native.AnimationMixer.setTimeScale(this.mixer, speed)
      }
    },
    // 停止播放
    async stopHandle() {
      const status = this.walking
      if (status) {
        // 小人在行走过程中，暂停播放
        const manMixer = await this.player.Native.SkeletonNode.mixer(this.personNode)
        const walkClipAction = await this.player.Native.AnimationAction.clipAction(manMixer, 'walk')
        await this.player.Native.AnimationAction.setPaused(walkClipAction, true)
        await this.player.Native.AnimationMixer.setPause(this.mixer, true)
      } else {
        // 小人在巡检点处，暂停播放
        // eslint-disable-next-line no-lonely-if
        if (this.playTimer) {
          clearTimeout(this.playTimer)
          this.playTimer = null
        }
      }
      this.isPlay = false
    },
    // 开始播放
    async playHandle() {
      this.isPlay = true
      const status = this.walking
      if (status) {
        // 正在走动中
        const manMixer = await this.player.Native.SkeletonNode.mixer(this.personNode)
        const walkClipAction = await this.player.Native.AnimationAction.clipAction(manMixer, 'walk')
        await this.player.Native.AnimationAction.setPaused(walkClipAction, false)
        await this.player.Native.AnimationMixer.setPause(this.mixer, false)
      } else {
        // 在巡检点中
        const idx = this.curPointInfo.idx
        const point = this.allPoints[idx]
        let bool = true
        if (point.isEnd) {
          bool = false
        }
        await this.selectPoint(point, bool, 'click')
      }
    },
    // 上一个点
    async prePoint() {
      this.pointLoading = true
      if (this.isShowRoute) {
        await this.player.Native.Route.clear()
      }
      let point = {}
      if (this.curPointInfo.idx === 0) {
        point = this.allPoints[this.allPoints.length - 1]
      } else {
        point = this.allPoints[this.curPointInfo.idx - 1]
      }
      let bool = true
      if (point.isEnd) {
        bool = false
      } else if (!point.isEnd) {
        if (!this.walking) {
          this.ramenIndex -= 1
        }
      }

      // 清除所有轨道数据
      await this.player.Native.KeyframeTrack.clearTrack(this.actionData.clip)
      await this.player.Native.AnimationMixer.setTime(this.mixer, 0)
      await this.cancelFollow()
      await this.player.Native.TargetFollow.unfollow()
      await this.player.Native.AnimationAction.stop(this.actionData.action)
      await this.setCurPoint(point, true)
      await this.selectPoint(point, bool, 'click')
      this.pointLoading = false
    },
    // 点击时调用，下一个点
    async clickNextPoint() {
      this.pointLoading = true
      if (this.isShowRoute) {
        await this.player.Native.Route.clear()
      }
      // 清除所有轨道数据
      await this.nextPoint(this.walking, true)
      this.pointLoading = false
    },
    // 自动播放时候调用
    // 下一个点
    async nextPoint(walking = false, isClick = false) {
      let point = {}
      if (this.curPointInfo.idx >= this.allPoints.length - 1) { // 到达终点
        const end = this.allPoints.length - 1
        point = this.allPoints[end]
      } else if (walking) { // 正在ab两点中走动
        point = this.allPoints[this.curPointInfo.idx]
      } else {
        point = this.allPoints[this.curPointInfo.idx + 1]
        await this.setCurPoint(point, isClick)
      }
      let bool = true
      if (point.isEnd) {
        bool = false
      } else if (!point.isEnd) {
        if (this.ramenIndex === this.ranmenRouteList.length - 1) {
          this.ramenIndex = 0
        } else {
          this.ramenIndex += 1
        }
      }
      // 清除所有轨道数据
      await this.player.Native.KeyframeTrack.clearTrack(this.actionData.clip)
      await this.player.Native.AnimationMixer.setTime(this.mixer, 0)
      await this.cancelFollow()
      await this.player.Native.TargetFollow.unfollow()
      await this.player.Native.AnimationAction.stop(this.actionData.action)
      await this.selectPoint(point, bool, 'next')
    },
    // playlist传入
    async getRouteListByPlayList() {
      this.routeLoading = true
      const allPoints = []
      this.playInfo.routePoints.forEach((item, index) => {
        item.routeId = `${item.id}${index}`
        item.inspectPoints = item.inspectPoints.filter((obj) => { return obj.checked === true })
        item.inspectPoints.forEach((point, itemIndex) => {
          point.r_id = item.id
          point.pointId = `${item.routeId}_${point.id}`
          point.perspective = JSON.parse(point.perspective || '{}')
          point.pos = [point.xPoint, point.yPoint, point.zPoint]
          point.speed = item.speed
          point.isBegin = itemIndex === 0 ? 1 : 0
          point.isEnd = item.inspectPoints.length - 1 === itemIndex ? 1 : 0
          point.standardText = point.description ? `巡检标准：${point.description}` : ''
          point.row = index
          point.description = point.description ? point.description.split('\n') : []
          point.actionSystem = point.actionSystem ? JSON.parse(point.actionSystem) : []
        })
        allPoints.push(...item.inspectPoints)
      })
      this.routeList = this.playInfo.routePoints
      if (allPoints.length) {
        allPoints.forEach((item, index) => {
          item.idx = index
        })
        this.curChangeSpeed = allPoints[0].speed
        // 初始化小人
        const ramenPointTemp = await this.getRamenPoint(this.playInfo.routePoints)
        const ramenPoint = compRamenRoute(ramenPointTemp) // 处理巡检路线
        this.destroyLock = false
        await setRamenNew(ramenPoint)
        this.destroyLock = true
        await this.setCurPoint(allPoints[0])
        // 播放巡检点
        await this.selectPoint(allPoints[0], true)
      }
      this.allPoints = allPoints
      this.routeLoading = false
    },
    // 遍历循环获取播放列表中的路径点
    async getRamenPoint(d) {
      const res = []
      for (let i = 0; i < d.length; i += 1) {
        // eslint-disable-next-line
        const [err, data] = await roamPointApi.getList({ inspectRouteId: d[i].id })
        if (!err) {
          const t = Object.assign(data, d[i])
          res.push(t)
        }
      }
      return res
    },
    // 点击播放巡检点
    async clickPoint(point, rIndex) {
      this.pointLoading = true
      if (this.isShowRoute) {
        await this.player.Native.Route.clear()
      }
      // 先让小人停止，并切换视角到那个点中
      const t = point.idx - rIndex
      let bool = true
      if (point.isEnd) {
        bool = false
      } else if (!point.isEnd) {
        if (t === this.ranmenRouteList.length) {
          this.ramenIndex = 0
        } else {
          this.ramenIndex = t
        }
      }
      // 小人走到了巡检点，准备走下一段路
      // 清除所有轨道数据
      await this.player.Native.KeyframeTrack.clearTrack(this.actionData.clip)
      await this.player.Native.AnimationMixer.setTime(this.mixer, 0)
      // 先清除interval，再设置unfollow
      await this.cancelFollow()
      this.player.Native.TargetFollow.unfollow()
      await this.player.Native.AnimationAction.stop(this.actionData.action)
      await this.setCurPoint(point, true)
      await this.selectPoint(point, bool, 'click')
      setTimeout(() => {
        this.pointLoading = false
      }, 500)
    },
    // 设置当前点，并且播放相对于的缺陷信息和报警统计和视频监控
    async setCurPoint(point, isClick = false) {
      await this.removeAllDot()
      voiceArr = []
      insertCount = 0
      voiceIndex = 0
      window.speechSynthesis.cancel()
      stopVoice = false

      if (this.playTimer) {
        clearTimeout(this.playTimer)
        this.playTimer = null
      }
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
      // 巡检完成调用
      await inspectRouteApi.inspectPointPlay({
        body: {
          inspectRouteRecordId: this.playInfo.batchNo,
          inspectRouteId: point.r_id,
          inspectPointId: point.id,
          lastInspectPointId: this.curPointInfo.inspectPointId,
        }
      })
      await this.getTagPanelInfo(point.tags, point.id)
      // 展示右侧报警信息、视频监控
      this.$emit('sendInfoToRightDialog', 'detail', { inspectPointId: point.id, cameras: point.cameras })
      await this.sleep(1000)
      await initIdleAniInfo(point.actionSystem)

      if (this.curPointInfo && this.curPointInfo.pointId) {
        // 给上一个点打勾
        this.allPoints[this.curPointInfo.idx].finished = true
      }

      this.curPointInfo = {
        routeId: point.pointId.split('_')[0],
        routeNo: point.row,
        pointId: point.pointId,
        idx: point.idx,
        inspectPointId: point.id,
        isEnd: point.isEnd,
        isBegin: point.isBegin,
        standardText: point.standardText
      }
      setTimeout(() => {
        if (point.standardText && this.readStandard) {
          startVoice(point.standardText)
        }
      }, 1000)
      // 位置滚动
      const pointRef = document.getElementById(point.pointId)
      pointRef &&
        pointRef.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        })

      setTimeout(() => {
        this.autoScroll()
      }, 1000)
    },
    // 设置当前播放点
    async selectPoint(point, isRamen, action) {
      if (this.backLoading) return

      // 加入程序锁
      this.destroyLock = false
      // 切换视角 把小人放到视角点
      const perspective = point.perspective
      if (perspective.eye) {
        this.cloudRender.Camera.moveCamera('CameraParam', perspective, 1)
      }
      if (!pointMarkerId) {
        await this.createMarker(point)
      } else {
        await this.updateMarkers(point)
      }
      // 将小人设置到视角点上面 并设置朝向
      // 并设置待机动作
      await this.player.Native.NodeProxy.setLocalTranslation(this.personNode, point.pos)
      if (point.towards) {
        const quat = EulerAngle.toQuat([0, 0, point.towards])
        await this.player.Native.NodeProxy.setLocalRotation(this.personNode, quat)
      }
      setIdle()
      this.walking = false
      // lock end
      this.destroyLock = true
      if (this.isPlay) {
        // 根据播放倍数计算停留时间
        let stayTime = point.stayTime
        let changeSpeed = this.curChangeSpeed
        if (!this.isManualSelectSpeed) {
          // 不是手动选择的倍数，则是配置的倍数
          changeSpeed = point.speed
          this.curChangeSpeed = point.speed
        }
        stayTime = (stayTime / changeSpeed).toFixed(2) * 1000
        this.playTimer = setTimeout(async () => {
          // 停止小人待机动作 并停止小人所有动作
          destroyIdleAniInfo()
          const manMixer = await this.player.Native.SkeletonNode.mixer(this.personNode)
          await this.player.Native.AnimationAction.stopActions(manMixer)
          if (isRamen) {
            this.destroyLock = false
            let nextPointInfo = null
            // 选择下一个点的信息
            if (this.curPointInfo.idx >= this.allPoints.length - 1) {
              nextPointInfo = this.allPoints[0]
            } else {
              nextPointInfo = this.allPoints[this.curPointInfo.idx + 1]
            }
            await this.setCurPoint(nextPointInfo)

            this.pointLoading = true
            // 加载小人轨道
            await this.loacPartAction(this.ranmenRouteList[this.ramenIndex], false)
            this.pointLoading = false
            this.walking = true
            // 加载route
            if (this.isShowRoute) {
              const route = await this.player.Native.Route.create(0)
              _.forEach(this.ranmenRouteList[this.ramenIndex], async (p) => {
                await this.player.Native.Route.appendControlPoint(route, [
                  p.xPoint,
                  p.yPoint,
                  p.zPoint,
                ])
              })
            }
            // 跟随视角切换
            const shelterInterval = await changeFollow(this.personNode)
            this.shelterInterval = shelterInterval
            this.destroyLock = true
          } else if (action === 'next') {
            let num = 0
            if (this.curPointInfo.idx >= this.allPoints.length - 1) {
              num = 0
            } else {
              num = this.curPointInfo.idx + 1
            }
            const pointNew = this.allPoints[num]
            await this.setCurPoint(pointNew)
            this.nextPoint(true)
          } else if (action === 'click') {
            let p = {}
            if (point.idx >= this.allPoints.length - 1) {
              p = this.allPoints[0]
            } else {
              p = this.allPoints[point.idx + 1]
            }
            this.clickPoint(p, p.row)
          }
        }, stayTime)
      }
    },
    sleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, time)
      })
    },
    async createMarker(point) {
      const option = {
        id: 'inspectPointMarker',
        pos: point.pos,
        background: 'sample',
        nodeOffset: [0, 0],
        text: point.name,
        textColor: '#ffffffff',
        hasTriangle: true,
        markPosType: 4,
      }
      const res = await this.cloudRender.Marker.createBySingleLine(option)
      if (res.data?.length) {
        pointMarkerId = res.data[0]
      }
    },
    async updateMarkers(item) {
      await this.cloudRender.Marker.updateBySingleLine({
        id: pointMarkerId,
        pos: item.pos,
        text: item.name,
      })
    },
    // 获取测点面板数据
    async getTagPanelInfo(tags, inspectPointId) {
      const tagIds = tags.map((item) => { return item.tagId })
      const [err, res] = await inspectPointApi.getTagPanelInfo({
        tagIds,
        inspectPointId
      })
      if (!err) {
        const mpIdMap = {}
        res.forEach((item) => {
          if (item.panels.length) {
            item.measurePoints = item.panels[0]?.measurePoints.slice(0, 10) || []
          } else {
            item.measurePoints = item.measurePoints.slice(0, 10)
          }
          item.measurePoints.forEach((points) => {
            mpIdMap[points.measuringPointId] = points
          })
        })
        // 测点订阅
        const BulkAddDto = []
        Object.keys(mpIdMap).forEach((point) => {
          BulkAddDto.push({
            measuringPointId: point,
            pointCode: mpIdMap[point].pointCode || '',
            value: mpIdMap[point].value,
            alarmLevel: mpIdMap[point].alarmLevel || '',
          })
        })
        this.tagList = res
        speakDataMap = {}
        try {
          await inspectConnection.invoke('BulkAddDto', BulkAddDto)
        } catch (e) {
          // throw e
        }
        this.curTagIndex = 0
        if (this.tagTimer) {
          clearInterval(this.tagTimer)
          this.tagTimer = null
        }
        if (this.tagList.length > 1) {
          // 设备切换展示
          this.tagTimer = setInterval(() => {
            if (this.curTagIndex < this.tagList.length - 1) {
              this.curTagIndex += 1
            } else {
              this.curTagIndex = 0
            }
          }, 8000)
        }
      }
    },
    // 测点数据更新
    websocketUpdatePanel(list) {
      const mpIdMap = {}
      list.forEach((item) => {
        mpIdMap[item.measuringPointId] = item
      })
      this.tagList.forEach((tagItem, index) => {
        let flag = true
        tagItem.measurePoints.forEach((pointItem) => {
          const mpInfo = mpIdMap[pointItem.measuringPointId]
          if (mpInfo) {
            pointItem.alarmLevel = mpInfo.alarmLevel
            pointItem.value = mpInfo.value
            if (this.curTagIndex === index && mpInfo.alarmLevel && mpInfo.alarmLevel !== 'normal') {
              flag = false
            }
          }
        })
        if (!flag) {
          this.setAlarmVoice()
        }
      })
    },
    // 报警语音播报
    setAlarmVoice() {
      let flag = true
      this.curTagInfo.measurePoints.forEach((item) => {
        if (item.alarmLevel && item.alarmLevel !== 'normal') {
          flag = false
          if (!speakDataMap[item.pointCode]) {
            if (this.readStandard) {
              interCutVoice(`请注意，${this.curTagInfo.tagName}，${item.shortName || item.pointName}有异常`)
            } else {
              interCutVoice(`请注意，${this.curTagInfo.tagName}，${item.shortName || item.pointName}有异常`, true)
            }
            speakDataMap[item.pointCode] = true
          }
        }
      })
      if (!flag) {
        this.showAlarm = true
      } else {
        this.showAlarm = false
      }
    },
    // 清空订阅测点
    async removeAllDot() {
      try {
        await inspectConnection.invoke('RemoveAllDto')
      } catch (e) {
        // throw e
      }
    },

    // 加载小人当前走的路线
    // path 为路径点
    async loacPartAction(path, bool) {
      // eslint-disable-next-line no-loop-func
      const timePositions = _.map(path, (el) => {
        const time = el.UnixTime
        return {
          time,
          point: [el.xPoint, el.yPoint, el.zPoint],
        }
      })
      // eslint-disable-next-line no-await-in-loop
      const actionPtr = await loadAction(
        {
          nodePtr: this.personNode,
          timePositions,
        },
        this.mixer,
        '0000',
        this.player
      )
      if (!bool) {
        // eslint-disable-next-line no-await-in-loop
        await this.player.Native.AnimationMixer.setPause(this.mixer, false)
      }
      this.actionData = actionPtr
      const manMixer = await this.player.Native.SkeletonNode.mixer(this.personNode)
      const clipAction = await this.player.Native.AnimationAction.clipAction(manMixer, 'walk')
      await this.player.Native.AnimationAction.fadeIn(clipAction, 0.1)
      this.player.Native.AnimationAction.play(actionPtr.action)
      this.isPlaying = true
    },
    async cancelFollow() {
      if (this.shelterInterval) {
        clearInterval(this.shelterInterval)
        this.shelterInterval = null
      }
      if (this.mouseMoveTimeout) {
        clearTimeout(this.mouseMoveTimeout)
        this.mouseMoveTimeout = null
      }
    },
    // switch路径更改
    async routeChange(val) {
      if (val) {
        const route = await this.player.Native.Route.create(0)
        _.forEach(this.ranmenRouteList[this.ramenIndex], async (p) => {
          await this.player.Native.Route.appendControlPoint(route, [p.xPoint, p.yPoint, p.zPoint])
        })
      } else {
        await this.player.Native.Route.clear()
      }
    },
    // 移动鼠标切换视角，10秒后在切换视角
    cameraChange() {
      const e = document.getElementById('playerEngineId')
      e.addEventListener('mouseup', this.cameraMouseUp)
    },
    async cameraMouseUp() {
      await this.cancelFollow()
      // 若在巡检点处拖动则不执行下一步
      const bool = !this.walking
      if (bool) {
        return
      }
      this.mouseMoveTimeout = setTimeout(async () => {
        const shelterInterval = await changeFollow(this.personNode)
        this.shelterInterval = shelterInterval
      }, 1000 * 10)
    },
    /**
     * @description: 关闭巡检功能
     * @return {*}
     */
    async cancelHistoryPath() {
      // 清除混合器对象 取消监听事件
      this.player.Native.AnimationAction.EventActionUpdate.disconnect(actionUpdate)
      if (this.mixer) {
        await this.player.Native.AnimationMixer.removeMixer(this.mixer)
      }
      this.mixer = null
      this.ranmenRouteList = []
      this.ramenIndex = 0
      /**
       * 保存track信息
       * clip 动画片段对象
       * action 动画片段动作控制器
       * trackT trackR 轨道信息
       */
      this.actionData = {}
      await this.player.Native.TargetFollow.unfollow()
      this.isPlaying = false
      // 清除路径
      if (this.isShowRoute) {
        await this.player.Native.Route.clear()
      }
    },
    async removeMouseUp() {
      const e = document.getElementById('playerEngineId')
      e.removeEventListener('mouseup', this.cameraMouseUp)
      if (this.mouseMoveTimeout) {
        clearTimeout(this.mouseMoveTimeout)
      }
    },
    // 删除任务， 退出
    async toBackHandle() {
      if (this.backLoading) return
      this.backLoading = true

      if (this.playTimer) {
        clearTimeout(this.playTimer)
        this.playTimer = null
      }
      window.speechSynthesis.cancel()
      voiceArr = []

      await this.removeMouseUp()

      inspectRouteApi.inspectRoutePlayComplete({
        inspectRouteRecordId: this.playInfo.batchNo
      })
      speakDataMap = {}

      const intervalId = setInterval(async () => {
        const rotateFinish = getRotateFinish()
        if ((this.destroyLock && rotateFinish)) {
          clearInterval(intervalId)
          // 取消跟随
          await this.cancelFollow()
          // 停止小人待机动作 并停止小人所有动作和后续动作
          destroyIdleAniInfo()
          clearNextAni()
          await this.backHandle()
          destroyCameraVm()
          destroyVm()
        }
      }, 2000)
      window.speechSynthesis.cancel()
      voiceArr = []
      try {
        inspectAutoDiscount = false
        await inspectConnection.invoke('StopConnection')
        inspectConnection = null
      } catch (e) {
        // throw e
      }
      this.cancelFollow()
      if (this.tagTimer) {
        clearInterval(this.tagTimer)
        this.tagTimer = null
      }
      // 离开页面关闭报警闪烁
      this.$emit('sendInfoToRightDialog', 'detail', { openAlarmFlicker: false, controlAlarm: true })
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
      clearTimeout(this.cameraTimer)
    },
    // 返回
    async backHandle() {
      await this.cancelHistoryPath()
      this.player.Native.NodeProxy.destroyNode(this.personNode)
      this.personNode = null
      if (pointMarkerId) {
        await this.cloudRender.Marker.destroyMarker(pointMarkerId)
        pointMarkerId = null
      }
      this.$emit('back')
    },
    // 初始化连接
    init() {
      // 建立连接
      const url = `${this.websocketServer}/SisHub`
      // const url = 'http://192.168.80.157:44386/SisHub'
      inspectConnection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        // .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build()

      // 监听面板测点信息
      inspectConnection.on('MsgResult', (data) => {
        // console.log('panel MsgResult', data)
        this.websocketUpdatePanel(data)
      })

      inspectConnection.onclose(() => {
        if (inspectAutoDiscount) {
          setTimeout(() => {
            this.reStartInspectConnect()
          }, 5000)
        }
      })

      // 开始连接
      inspectConnection
        .start()
        .then(() => {})
        .catch((err) => {
          // throw err
        })
    },
    async reStartInspectConnect() {
      // 开始连接
      try {
        await inspectConnection.start()
      } catch (e) {
        setTimeout(() => {
          this.reStartInspectConnect()
        }, 5000)
      }
    },
  },
  async created() {
    inspectAutoDiscount = true
    if (this.playInfo.routePoints.length) { // 传进来了巡检点
      this.getRouteListByPlayList()
    }
    this.init()
    this.cameraChange()
    window.inspectScreen = this
  },
  mounted() {
    mountVm(this)
    createPersonNode()
    mountCameraVm(this)
  },
  async beforeDestroy() {
    this.toBackHandle()
  },
}
</script>

<style lang="scss" scoped>
.inspect-left {
  display: flex;
  overflow: hidden;
  height: 100%;
  flex-direction: column;

  .route-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #fff;

    .play-rate {
      margin-top: 6px;
      margin-right: 10px;
      color: #FF8900;
    }
  }

  .route-list {
    overflow: auto;
    font-size: 14px;
    color: #fff;
    flex: 1;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .route-item {
      .cur-route {
        padding: 4px 5px 4px 10px;
        font-size: 16px;
        color: #45F2EB;
        border: 1px solid #0E7A84;
        box-shadow: 0 6px 4px 0 #04112026;
        font-weight: bold;
      }
    }

    .point-list {
      .point-item {
        .point-item-info {
          .point-item-title {
            display: flex;
            justify-content: space-between;
            padding: 5px 0 0 15px;

            .title-box {
              word-break: break-all;
              margin-right: 5px;
            }

            .icon-finished {
              width: 18px;
              height: 18px;
            }
          }

          .point-standard-item {
            word-break: break-all;
          }

          .point-standard {
            overflow: auto;
            padding-left: 30px;
            max-height: 85px;
            color: #45F2EB;

            &::-webkit-scrollbar {
              width: 0;
            }
            // &:hover {
            //   max-height: 100%;
            // }
          }
        }

        .cur-point {
          position: relative;

          &::before {
            position: absolute;
            top: 9px;
            right: 3px;
            width: 10px;
            height: 10px;
            background: #FA8B14;
            border-radius: 50%;
            content: '';
          }
        }
      }
    }
  }

  .stop-btn {
    margin: 5px 0;
    height: 38px;
    font-size: 16px;
    text-align: center;
    color:#fff;
    background: linear-gradient(180deg, #137EE566 0%, #19A4DA66 100%),linear-gradient(-180deg, #05B0FF00 0%, #3BFFF566 100%);
    border-radius: 32px;
    box-shadow: inset 0 1px 15px 0 #77C4FF33;
    line-height: 38px;
  }

  .route-play__btns {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .change-speed {
      display: flex;
      font-size: 18px;
      color: #FFF9;

      .speed-text {
        padding: 0 12px;
        margin-left: 6px;
        color: #FFFC;
        background: #B0D4FE19;
      }
    }
  }
}

.inspect-right {
  position: fixed;
  top: 120px;
  right: 20px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 367px;
  height: calc(100vh - 140px);
  background-size: 100% 100%;
  background-image: var(--containerBgImg);

  .alarm-top-info {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 14px;
    color: #fff;

    .alarm-left {
      display: flex;
      align-items: center;

      .alarm-num {
        margin-left: 15px;
        min-width: 94px;
        font-size: 18px;
        text-align: center;
        color: #FF8900;
        background: #063F4B;
        font-weight: bold;
      }
    }

    .alarm-right {
      display: flex;
      align-items: center;
    }
  }

  .bug-box {
    flex: 1;
    overflow: auto;
  }

  .carousel-wrapper {
    margin-bottom: 10px;
    height: 207px;

    ::v-deep.el-carousel__container {
      height: 100% !important;
    }

    ::v-deep .el-carousel__button {
      width: 3px;
      height: 3px;
      background: white;
      border-radius: 100%;
    }

    ::v-deep .is-active {
      .el-carousel__button {
        width: 10px;
        height: 3px;
        background: #44F1FF;
        border-radius: 3px;
      }
    }

    .video-item {
      height: 100%;
      background: #0E2E3C;
    }
  }
}

.point-device-info {
  position: fixed;
  top: 120px;
  right: 390px;
  // padding: var(--containerPadding);
  min-width: 350px;
  color: #fff;
  background: rgba(16,58,68,0.69);
  border-radius: 10px;
  box-shadow: inset 0 0 142px 0 #06333D;

  .device-info-item {
    padding: 6px 10px 0;
    font-size: 14px;
    line-height: 14px;

    &:last-child {
      padding-bottom: 6px;
    }
  }

  .label-text {
    color: #FFFFFFB2;
  }

  .slight {
    color: #FEFF00;
  }

  .middle {
    color: #FA8B14;
  }

  .serious {
    color: #e83939;
  }
}
// .mask {
//   position: fixed;
//   left: 0;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   z-index: 10;
// }
</style>

<style lang="scss">
.speed-list-popover {
  min-width: 80px;
  background: rgba(16,58,68,0.69);
  border: none;
  box-shadow: inset 0 0 142px 0 #06333d;

  .speed-popover-content {
    text-align: center;
    color: #fff;
    line-height: 28px;

    .cur-speed {
      color: rgba(60, 248, 237, 1);
    }
  }
}
</style>
